"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateSpoilerPreferencesDto = instanceOfUpdateSpoilerPreferencesDto;
exports.UpdateSpoilerPreferencesDtoFromJSON = UpdateSpoilerPreferencesDtoFromJSON;
exports.UpdateSpoilerPreferencesDtoFromJSONTyped = UpdateSpoilerPreferencesDtoFromJSONTyped;
exports.UpdateSpoilerPreferencesDtoToJSON = UpdateSpoilerPreferencesDtoToJSON;
exports.UpdateSpoilerPreferencesDtoToJSONTyped = UpdateSpoilerPreferencesDtoToJSONTyped;
var TeamToggleDto_1 = require("./TeamToggleDto");
var GlobalToggleDto_1 = require("./GlobalToggleDto");
var SportToggleDto_1 = require("./SportToggleDto");
/**
 * Check if a given object implements the UpdateSpoilerPreferencesDto interface.
 */
function instanceOfUpdateSpoilerPreferencesDto(value) {
    return true;
}
function UpdateSpoilerPreferencesDtoFromJSON(json) {
    return UpdateSpoilerPreferencesDtoFromJSONTyped(json, false);
}
function UpdateSpoilerPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'global': json['global'] == null ? undefined : (0, GlobalToggleDto_1.GlobalToggleDtoFromJSON)(json['global']),
        'sports': json['sports'] == null ? undefined : (json['sports'].map(SportToggleDto_1.SportToggleDtoFromJSON)),
        'teams': json['teams'] == null ? undefined : (json['teams'].map(TeamToggleDto_1.TeamToggleDtoFromJSON)),
    };
}
function UpdateSpoilerPreferencesDtoToJSON(json) {
    return UpdateSpoilerPreferencesDtoToJSONTyped(json, false);
}
function UpdateSpoilerPreferencesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'global': (0, GlobalToggleDto_1.GlobalToggleDtoToJSON)(value['global']),
        'sports': value['sports'] == null ? undefined : (value['sports'].map(SportToggleDto_1.SportToggleDtoToJSON)),
        'teams': value['teams'] == null ? undefined : (value['teams'].map(TeamToggleDto_1.TeamToggleDtoToJSON)),
    };
}
